import {
  PromptKind,
  PromptScope,
} from "@redotech/redo-model/agents/returns-agents/prompts";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getPrompt = unaryRpc({
  name: "getPrompt",
  input: z.intersection(
    z.object({ kind: createEnum(PromptKind) }),
    z.discriminatedUnion("scope", [
      z.object({ scope: z.literal(PromptScope.DEFAULT) }),
      z.object({ scope: z.literal(PromptScope.USER), userId: zExt.objectId() }),
      z.object({ scope: z.literal(PromptScope.TEAM), teamId: zExt.objectId() }),
    ]),
  ),
  output: z.object({ promptText: z.string().nullable() }),
});
